// URLの値からsortで選ばれているテキストを取得し出力
// プルダウン開閉
// スマホの絞り込みボタン開閉専用
// sort選択された値のテキストを取得して表示
// 商品並び替え
// PC用絞り込みナビのsticky制御
// チェックボタン数制限
// リセットボタン
// チェックを取得しURLを変更する
// チェックを取得しURLを変更する pc用
// チェックを取得しURLを変更する sp用
// URLからタグを取得し、チェックボタンにチェックを入れる

//画面が読み込まれたら
$(document).ready(function () {
  //URLの値からsortで選ばれているテキストを取得し出力
  const collectionSelect = $('#collection-sort-by option');
  const selectOptions = collectionSelect
    .map(function () {
      return $(this).val();
    })
    .get();
  // console.log(selectOptions);

  const query = new URLSearchParams(location.search);
  const sortedType = query.get('sort_by');

  if (!sortedType) {
    $('.sort__text-label').text('新着順');
  } else {
    for (let int = 0; selectOptions.length > int; int++) {
      if (sortedType == selectOptions[int]) {
        $(`#collection-sort-by option[value="${selectOptions[int]}"]`).prop(
          'selected',
          true
        );

        const sortedName = $(
          `#collection-sort-by option[value="${selectOptions[int]}"]`
        ).text();
        $('.sort__text-label').text(sortedName);
      }
    }
  }

  // プルダウン開閉
  const collToggleBtns = $('.js-collnav-toggle');
  const collNavContents = $('.js-collnav-content');
  const toggleIcon = $('.js-collnav-icon');
  const bgShow = $('.js-navbar-bg');

  collToggleBtns.map((index, toggleBtn) => {
    $(toggleBtn).on('click', () => {
      $(collNavContents[index]).slideToggle();
      $(bgShow[index]).toggleClass('bg-show');
      if ($(toggleBtn).find(toggleIcon).text() === '-') {
        $(toggleBtn).find(toggleIcon).text('+');
      } else {
        $(toggleBtn).find(toggleIcon).text('-');
      }
    });
  });

  // スマホの絞り込みボタン開閉専用
  const spCollToggleBtns = $('.js-collection-sp-toggle');
  const spCollNavContent = $('.js-collection-sp-content');

  spCollToggleBtns.on('click', () => {
    if (spCollNavContent.css('display') == 'none') {
      spCollNavContent.slideDown();
    } else {
      spCollNavContent.slideUp();
    }
  });
});

//sort選択された値のテキストを取得して表示
$('#collection-sort-by').on('change', function () {
  var $this = $(this);
  var $option = $this.find('option:selected');
  console.log($option.text());
  $('.sort__text-label').text($option.text());

  // onchange後にフォーカスしてるのが嫌な場合
  $this.blur();
});

//商品並び替え
Shopify.queryParams = {};
if (location.search.length) {
  for (
    var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&');
    i < aCouples.length;
    i++
  ) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(
        aKeyValue[1]
      );
    }
  }
}

$('#collection-sort-by')
  .val('{{ collection.sort_by | default: collection.default_sort_by | escape }}')
  .bind('change', function () {
    Shopify.queryParams.sort_by = jQuery(this).val();
    location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
  });

//PC用絞り込みナビのsticky制御
$(window).on('load', () => {
  const collectionNav = $('#collection-nav');
  var navHeight = 0;
  var navView = 500; //ナビが見えている量
  var navScrolledPos = 0;
  var nowScrollPos = 0;
  var navPosition = 0;
  var fixedPosition = 0;
  var navDefPosition = collectionNav.offset().top;
  var upJudg = false;
  var passValue = 0;
  var nextValue = 0;

  $(window).on('scroll', function () {
    navHeight = collectionNav.outerHeight();
    fixedPosition = navHeight - navView + navDefPosition;
    nowScrollPos = $(this).scrollTop();
    navPosition = collectionNav.offset().top;

    if (navScrolledPos >= nowScrollPos) {
      // 上げ
      upJudg = true;
      nextValue = passValue;
      if (nowScrollPos > navPosition) {
        collectionNav.offset({ top: navPosition + (navScrolledPos - nowScrollPos) });
      } else if (nowScrollPos <= navPosition) {
        collectionNav.offset({ top: nowScrollPos });
      }
    } else {
      // //下げ
      passValue = nowScrollPos;
      if (upJudg == false && nowScrollPos > fixedPosition) {
        collectionNav.css('top', -fixedPosition);
      } else if (upJudg == true && nowScrollPos < fixedPosition) {
        collectionNav.offset({ top: navDefPosition });
        nextValue = 0;
      } else if (upJudg == true && nowScrollPos > fixedPosition) {
        // console.log(nextValue);
        if (nextValue > nowScrollPos) {
          collectionNav.offset({ top: navPosition - (nowScrollPos - navScrolledPos) });
        } else if (nextValue <= nowScrollPos) {
          collectionNav.css('top', -fixedPosition);
        }
      }
    }
    navScrolledPos = nowScrollPos;
    // console.log(navScrolledPos);
  });
});

// チェックボタン数制限
$('.check-count').map((index, btn) => {
  $(btn).on('click', function () {
    $(btn).parents('.check-limit').find('.check-count').prop('checked', false);
    $(btn).prop('checked', true);
  });
});

// リセットボタン
$('.reset-btn').map((index, btn) => {
  $(btn).on('click', function () {
    $(btn).parents('.checkbox-reset').find('input:checkbox').prop('checked', false);
  });
});

// チェックしURLを変更する
function urlToggle(btn, tags, pickers) {
  var newTags = [];
  const collectionHandle = $("#collection-handle").data("collection-handle");

  $(btn).on('click', function () {
    newTags = $(tags)
      .map(function () {
        return $(this).val();
      })
      .get();

    if (newTags.length) {
      var query = newTags.join('+');
      if ($(pickers).val()) {
        window.location.href = $(pickers).val() + '/' + query;
      } else {
        window.location.href = `/collections/${collectionHandle || 'all'}/` + query;
      }
    } else {
      if ($(pickers).val()) {
        window.location.href = $(pickers).val();
      } else {
        window.location.href = `/collections/${collectionHandle || 'all'}/`;
      }
    }
  });
}

// チェックしURLを変更する pc用
const pcBtn = '#collection-nav-pc .filter-btn';
const pcTags = '#collection-nav-pc .coll-tag:checked';
const pcPickers = '#collection-nav-pc .coll-picker:checked';
urlToggle(pcBtn, pcTags, pcPickers);

// チェックしURLを変更する sp用
const spBtn = '#collection-nav-sp .filter-btn';
const spTags = '#collection-nav-sp .coll-tag:checked';
const spPickers = '#collection-nav-sp .coll-picker:checked';
urlToggle(spBtn, spTags, spPickers);

// URLからタグを取得し、チェックボタンにチェックを入れる
let has_tags;
if ('{{ pages_current_tags }}' != '') {
  has_tags = true;
} else {
  has_tags = false;
}
// console.log(pages_current_tags);

// const current_host = location.host;
const current_path = location.pathname;
// const current_query = location.search;
// console.log(decodeURI(current_path));

// //hashを除去
const current_path_without_hash = String(current_path).replace('#', '');
// console.log(decodeURI(current_path_without_hash));

//collections/ここ/を取得する
var headTag;
// 最初のスラッシュを削除
if (current_path_without_hash.slice(0, 1) === '/') {
  headTag = current_path_without_hash.slice(1);
}
//collectionを削除して、/で分ける
headTag = headTag.slice(headTag.indexOf('/') + 1).split('/');

if (headTag.length > 1) {
  headTag = headTag[0];
}
headTag = decodeURI(headTag);
// console.log(headTag);

// 現在のタグを取得
let current_tags;
if (has_tags) {
  var backUrlTags = getCurrentTags(current_path_without_hash.replace(/\/+/g, '/'));
  backUrlTags = decodeURI(backUrlTags);
  if (headTag != 'all' && backUrlTags != 'all' && headTag != backUrlTags) {
    current_tags = `${headTag}+${backUrlTags}`;
  } else if (headTag != 'all' && headTag == backUrlTags) {
    current_tags = backUrlTags;
  } else if (headTag == 'all' && backUrlTags != 'all') {
    current_tags = backUrlTags;
  } else if (headTag == 'all' && backUrlTags == 'all') {
    current_tags = 'all';
  }
} else {
  current_tags = [];
}
// console.log(current_tags);
// console.log(decodeURI(current_tags));

function getCurrentTags(path) {
  let path_end_without_slash = path;
  if (path_end_without_slash.slice(-1) == '/') {
    path_end_without_slash = path_end_without_slash.slice(0, -1);
  }
  let reversed_path = path_end_without_slash.split('').reverse().join('');
  reversed_path = reversed_path.slice(0, reversed_path.indexOf('/', 0));
  // console.log(reversed_path);
  // console.log(reversed_path.indexOf("\/", 0));

  path_end_without_slash = reversed_path.split('').reverse().join('');
  let tags = path_end_without_slash.split(',');
  // console.log(decodeURI(tags));
  return tags;
}

// タグをデコード
current_tags = decodeURI(current_tags);
// console.log(current_tags);
// タグを＋で切り分け

current_tags = current_tags.split('+');
const current_tags_with_two_types = [
  ...current_tags.map((tag) => tag.replace('-', '・')),
  ...current_tags.map((tag) => tag.replace('-', ' '))
];
// console.log(current_tags);

const checkBox = document.getElementsByName('collection_nav');
// URLに含まれるタグにはチェックをいれる
for (let j = 0; checkBox.length > j; j++) {
  var checkboxId = checkBox[j].id;
  for (var num = 0; current_tags_with_two_types.length > num; num++) {
    if (checkboxId == current_tags_with_two_types[num]) {
      const checkedId = checkBox[j];
      checkedId.checked = true;

      // console.log(checkboxId);

      $(checkedId.closest('.js-collnav-content')).slideDown();
      $(checkedId).parents('.slide-control').find('.js-collnav-icon').text('-');
      $(checkedId).parents('.slide-control').find('.js-navbar-bg').addClass('bg-show');
    }
  }
}
